// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2h-uW","signatureBlock":"Footer_signatureBlock__1PCOj","signature":"Footer_signature__UrCFl"};